import { Typography } from "@mui/material";
import { useAi } from "src/context/AiContext";

export default function AiLayout_Header() {
  const { response } = useAi();

  return response.length === 0 && <Typography variant="h5">Miten voin auttaa?</Typography>;
}
